export class ChipItem {

  id: string;
  startNum: string;

  getId2(): string {
    let id2: string = this.startNum;
    while (id2.length < 25 ) {
      id2 = `0${id2}`;
    }
    return id2;
  }
}
